import { uniqueId } from '@disy/lib/unique-id';

/**
 * Sets the `aria-labelledby` attribute of the given element.
 *
 * _Note:_ Typically you don't need to do this manually, because a {@link import('@disy/ui/form-group').FormGroup} does it for you.
 */
export function labelledBy(el: Element, ariaLabelledBy: string | Element) {
  if (ariaLabelledBy instanceof Element) {
    ariaLabelledBy.id ||= uniqueId();
    ariaLabelledBy = ariaLabelledBy.id;
  }
  el.setAttribute('aria-labelledby', ariaLabelledBy);
}

export function ariaTrueFalse(el: Element, property: string): boolean;
export function ariaTrueFalse(el: Element, property: string, value: boolean): void;
export function ariaTrueFalse(el: Element, property: string, value?: boolean) {
  const attribute = `aria-${property}`;
  if (arguments.length === 2) {
    // get
    return el.getAttribute(attribute) === 'true';
  }

  // set
  if (value) {
    el.setAttribute(attribute, String(value));
  } else {
    el.removeAttribute(attribute);
  }
}

export function ariaTristate(el: Element, property: string): boolean;
export function ariaTristate(el: Element, property: string, value: boolean | 'mixed'): void;
export function ariaTristate(el: Element, property: string, value?: boolean | 'mixed') {
  const attribute = `aria-${property}`;
  if (arguments.length === 2) {
    // get
    const attributeValue = el.getAttribute(attribute);
    if (attributeValue === 'true') {
      return true;
    }
    if (attributeValue === 'false') {
      return false;
    }
    return 'mixed';
  }

  // set
  el.setAttribute(attribute, String(value));
}
